import { useGetFeaturedArtists } from '@bpm-web-app/swr-hooks';
import { useContext, useEffect, useMemo } from 'react';
import { LibraryTabsContext } from 'libs/utils/src/lib/library-tabs.context';
import { useUniqueArray } from '@bpm-web-app/utils';
import { ArtistCardImage, CardCarousel, CardGrid, GhostComponent } from '../shared';
import SeeMoreSupremeLayout from '../see-more-layout/see-more-supreme-layout';
import CardGhostLoading from '../shared/card/card-ghost-loading';

interface FeaturedArtistsProps {
    title?: string;
    isDataLoaded?: boolean;
    setIsDataLoaded?: (loaded: boolean) => void;
    indexPage?: boolean;
}

export function FeaturedArtists({
    title = 'Featured Artists',
    isDataLoaded,
    setIsDataLoaded,
    indexPage = false,
}: FeaturedArtistsProps) {
    const { libraryProperty } = useContext(LibraryTabsContext);
    const { data, isLoading } = useGetFeaturedArtists(libraryProperty);
    const getFeaturedArtistsData = data?.data;
    const ghostLoadingItems = useUniqueArray(20);

    useEffect(() => {
        if (setIsDataLoaded) {
            if (isLoading === false && getFeaturedArtistsData) {
                setIsDataLoaded(true);
            } else {
                setIsDataLoaded(false);
            }
        }
    }, [isLoading, getFeaturedArtistsData, setIsDataLoaded]);

    const shouldDisplayGhostLoading = useMemo(() => isDataLoaded === false || isLoading, [isDataLoaded, isLoading]);

    if (shouldDisplayGhostLoading && indexPage === false) {
        return (<GhostComponent type="cards" elementsCount={10} title={title} cardSize="small" />);
    }

    if (indexPage) {
        return (
            <div>
                <SeeMoreSupremeLayout
                    pageTitle={title}
                    mobileChildren={
                        <CardGrid cardType="artist-card">
                            {isLoading && ghostLoadingItems.map((uuid) => <CardGhostLoading key={`artist-card-ghost-${uuid}`} cardSize="small" />)}
                            {!isLoading &&
                                getFeaturedArtistsData?.map((item) => (
                                    <ArtistCardImage
                                        key={item.id}
                                        artist={item}
                                    />
                                ))}
                        </CardGrid>
                    }
                    desktopChildren={
                        <CardGrid cardType="artist-card">
                            {isLoading && ghostLoadingItems.map((uuid) => <CardGhostLoading key={`artist-card-ghost-${uuid}`} cardSize="small" />)}
                            {!isLoading &&
                                getFeaturedArtistsData?.map((item) => (
                                    <ArtistCardImage
                                        key={item.id}
                                        artist={item}
                                    />
                                ))}
                        </CardGrid>
                    }
                />
            </div>
        );
    }

    return (
        <div>
            <CardCarousel title={title} seeMorePath="/featured-artists/all">
                {getFeaturedArtistsData &&
                    getFeaturedArtistsData.map((item) => (
                        <ArtistCardImage
                            key={item.id}
                            artist={item}
                        />
                    ))}
            </CardCarousel>
        </div>
    );
}
